import { MakeRequest } from './commonTypes';
import { createAdapter } from './adapters/createAdapter';
import createPlainClient from './createClient';
import { CreateHttpClientParams } from './commonTypes';
import getUserAgentHeader from './utils/getUserAgent';
export * from './exportTypes'
export { RestAdapter } from './restAdapter';
export type {AxiosError} from 'axios'

const __VERSION__ = 1.0;

interface UserAgentParams {
  /**
   * Application name and version e.g myApp/version
   */
  application?: string;
  /**
   * Integration name and version e.g react/version
   */
  integration?: string;

  feature?: string;
}

export type ClientOptions = CreateHttpClientParams & UserAgentParams;

function createClient(
  params: ClientOptions
  // opts: {
  //   type?: 'plain';
  //   alphaFeatures?: string[];
  // } = {}
) {
  const userAgent = getUserAgentHeader(
    `${'digicommerce'}/${__VERSION__}`,
    params.application,
    params.integration,
    params.feature
  );

  const adapter = createAdapter(params);

  // Parameters<?> and ReturnType<?> only return the types of the last overload
  // https://github.com/microsoft/TypeScript/issues/26591
  // @ts-expect-error
  const makeRequest: MakeRequest = (
    options: Parameters<MakeRequest>[0]
  ): ReturnType<MakeRequest> => adapter.makeRequest({ ...options, userAgent });

  return createPlainClient(makeRequest);
}

export { createClient };
